import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

export const tabTableEditAction = (action) => {
    return (props) => {
        // eslint-disable-next-line no-unused-vars
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const { tab, tabIndex } = action;
        const { id } = params;
        const value = "edit";
        const label = "Edit";

        const navigate = useNavigate();
        const handleOnClick = () => {
            navigate(`${tab}/edit/${id}/${tabIndex}`);
            onClick(value);
        };
        return (
            <MenuItem
                key={value}
                value={value}
                label={value}
                icon={<EditOutlined />}
                onClick={handleOnClick}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
